import React from "react";

import "./Footer.css";

const footer = () => (
  <div className="footer-container">
    <div className="social-media-container">
      <a
        href="https://www.linkedin.com/in/christian-lamborghini-78542428/"
        className="icon-button"
        target="_blank"
      >
        <svg className="footer-icon linkedin">
          <use xlinkHref="img/sprite.svg#icon-linkedin-logo" />
        </svg>
        <span className="span-linkedin" />
      </a>
      <a
        href="https://github.com/clamborg?tab=repositories"
        className="icon-button"
        target="_blank"
      >
        <svg className="footer-icon github">
          <use xlinkHref="img/sprite.svg#icon-github-logo" />
        </svg>
        <span className="span-github" />
      </a>
    </div>
    <a
      href="https://firebasestorage.googleapis.com/v0/b/portfolio-contact-f7427.appspot.com/o/ChristianLamborghini-Resume-FinalV3.pdf?alt=media&token=10ad9a0e-79fe-472a-bbd7-76ac0e38a86f"
      target="_blank"
    >
      <div className="footer-btn-resume">Resum&eacute;</div>
    </a>
  </div>
);

export default footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js